/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-07-28 10:37:01
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-09-01 15:25:31
 * @FilePath: \mpc-3\features\mpc-common\src\utils\showAlert.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import * as React from 'react';
import { Alert, Message } from '@bedrock/components';

interface showAlertProps {
  type: string;
  message: string;
  hideDelay?: number;
}

const showAlert = (props: showAlertProps) => {
  const { type = 'success', message, hideDelay = 3000 } = props;
  console.log('message', message, type);
  // 如果msg中有 \n 则替换为 <br/>
  const showMsg = () => {
    if (!message) return '';

    const lines = message.split('\n');
    if (lines.length === 1) {
      return message;
    }

    return lines.map((item, index) => (
      <React.Fragment key={index}>
        {item}
        {index < lines.length - 1 && <br />}
      </React.Fragment>
    ));
  };

  const config = {
    content: showMsg(),
    duration: hideDelay / 1000,
    colored: true,
    style: {
      position: 'fixed',
      maxWidth: '800px',
      marginTop: '45vh',
      left: '50%',
      transform: 'translateX(-50%)',
    },
  };

  if (Message[type]) {
    Message[type](config);
  } else {
    Message.info(config);
  }
  return;
};

// 历史代码中会在全局拦截器中调用showAlert，也可能会在具体业务代码中调用showAlert
const alertCache = {};
// 加入防抖，如果在100ms内连续调用，且type和message相同，则不再弹出
const showAlertDebounce = (props: showAlertProps) => {
  const { type, message } = props;
  const key = `${type}-${message}`;
  if (alertCache[key]) {
    clearTimeout(alertCache[key]);
  }
  alertCache[key] = setTimeout(() => {
    showAlert(props);
    delete alertCache[key];
  }, 40);
};

export default showAlertDebounce;
